<template>
	<div class="row">
    <div class="col-md-12" style="background:var(--blue)"><p class="header-bar">PORTFOLIO SUMMARY REPORT</p></div>
    <div class="row col-md-12">
      <div class="col-md-4 form-group">
      </div>
      <div class="col-md-2 form-group">
      </div>
      <div class="col-md-6 mt-4 mb-4">
        <a class="pull-right mr-2" href="javascript:;" @click="get_report_modal" title="Download Reports" v-if="can_access('report','download')"><i class="fa fa-archive" aria-hidden="true"></i> Download From Archives</a>
        <a class="pull-right" target="_blank" ref="download" href="javascript:;" @click.prevent="download"><i class="fa fa-file"></i> Generate IRESS Reports</a>
      </div>
    </div>
		<TableView :col="columns"  v-if="showTableView" :getData="getData" :Options="{tblContainerClass:'innerTable-style'}"/>    

    <b-modal ref="get-report-out" title="Download Reports" size="xl" hide-footer>
      <ReportsInExcel :file_prefix="filenameprefix"/>
    </b-modal>       
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    ReportsInExcel : () => import('@/components/Accounts/ReportsInExcel.vue'),
  },
  mixins: [common],
  props: ['row','report_date','base_currency'],
  data(){
  	return {
      showTableView: false,
      res: {},
      filenameprefix:'iress\\/'+this.row.account_number+'\\/',
      columns: (() => {
        const cols = [
          { title: 'Currency', field: 'lcy', tdClass:"p1rem" },
          { title: 'Security Type', field: 'type_of_security'},
          { title: 'Ticker', field: 'tidm' },
          { title: 'Name', field: 'issuer_name'},
          { title: 'Quantity', field: 'quantity', tdComp: 'Number', 'floatLength': 2},
          { title: 'Cost Price', field: 'cost_price' , tdComp: 'Number'},
          { title: 'Market Price', field: 'market_price', tdComp: 'Number'},
          { title: 'UnRealized PNL', field: 'unrealized_pnl', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Margin Rate(%)', field: 'margin', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Margin Value', field: 'margin_value', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Securities Value', field: 'securities_value', tdComp: 'Number', 'floatLength': 2 },
          { title: 'FX Rate', field: 'fx_rate', tdComp: 'Number' },
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  mounted() {
      let uri = 'portfolio_report?account_number='+this.row.account_number+'&report_date='+this.report_date+'&base_cur='+this.base_currency;
      this.call_axios(uri).then(res => {
          this.res = res;
          this.showTableView = true;
      });
  },
  methods: {
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      var result = this.duplicate(this.res);
      result.response.data.result = result.response.data.result.slice(offset, offset+limit);
      return result;
    },
    download() {
      let uri = 'generate_iress_report?account_number='+this.row.account_number+'&report_date='+this.report_date+'&base_cur='+this.base_currency;
      this.call_axios(uri).then(res => this.$toasted.success(res.response.result, {duration:2500}));
    },
    get_report_modal(){
      this.$refs['get-report-out'].show();
    },
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>